import {createSlice} from "@reduxjs/toolkit";
import moment from "moment";

export const pinSlice = createSlice({
    name:'pin',
    initialState:{
        value:"",
        askPin:false,
        redirectUrl : "",
        tentative : 0,
        lastSeen : moment().format('YYYY-MM-DD HH:mm:ss'),
    },
    reducers:{
        createPin:(state,action)=>{
            state.value = action.payload;
        },
        setTentative:(state,action)=>{
            state.tentative = action.payload;
        },
        setLastSeen:(state,action)=>{
          state.lastSeen = moment().format('YYYY-MM-DD HH:mm:ss');
        },
        askPin:(state,action)=>{
            state.askPin = action.payload.value;
            state.redirectUrl = action.payload.redirectUrl || state.redirectUrl;
        },
    }
})

export const {askPin} = pinSlice.actions;
export const {createPin} = pinSlice.actions;
export const {setTentative} = pinSlice.actions;
export const {setLastSeen} = pinSlice.actions;

export default pinSlice.reducer;